import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { namLogo } from "../../assets/images";
import "./Login.css";

const Login = ({ setIsAuthenticated }: { setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // const defaultEmail = "geo@tech.com";
    // const defaultPassword = "admin@123";
    const defaultEmail = "demo@brlps.in";
    const defaultPassword = "brlps";
    if (email === defaultEmail && password === defaultPassword) {
      setIsAuthenticated(true);
      localStorage.setItem("isAuthenticated", "true");
      navigate("/chat"); // Corrected to /chat
    } else {
      alert("Invalid email or password");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-background-glow"></div>
      <div className="login-container">
        <div className="login-card">

          <div className="login-illustration">
            <img src={namLogo} alt="Smart Didi Logo" className="login-main-logo" />
          </div>

          <div className="login-brand-section">
            <h1 className="brand-title">
              {"SMART DIDI".split("").map((char, index) => (
                <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </h1>
            <p className="brand-subtitle">AI BOT FOR COMMUNITY EMPOWERMENT</p>
          </div>

          <div className="login-divider"></div>

          <div className="login-header">
            <div className="login-heading">SIGN IN</div>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <i className="fas fa-envelope"></i>
              <input
                required
                className="login-input"
                type="email"
                name="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="input-group">
              <i className="fas fa-lock"></i>
              <input
                required
                className="login-input"
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button className="login-submit-btn" type="submit">
              <span>SIGN IN</span>
            </button>
          </form>

          <div className="login-footer">
            Powered by <span>Jeevika</span>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Login;
